import { faBars, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from '@mui/material';
import { Accordion } from '@szhsin/react-accordion';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SlidePanel from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import AccordionItem from './accordion-item';
import './index.scss';

const Menu: { [x: string]: { name: string, path: string }[] | string } = {
  Services: [
    {
      name: 'Compliance Services',
      path: '/services'
    },
    {
      name: 'About Fly Compliant',
      path: '/services/about'
    },
    {
      name: 'Compliance Management',
      path: '/services/compliance-management'
    },
    {
      name: 'Certification Services',
      path: '/services/certification-services'
    },
    {
      name: 'Digital Solutions',
      path: '/services/digital-solutions'
    },
    {
      name: 'SMS',
      path: '/services/safety-management-system'
    },
  ],
  Software: [
    {
      name: 'Software Solutions',
      path: '/software'
    },
    {
      name: 'Levelflight',
      path: '/software/levelflight'
    },
    {
      name: 'Electronic Flight Bag',
      path: '/software/electronic-flight-bag'
    },
    {
      name: 'Electronic Recordkeeping',
      path: '/software/electronic-recordkeeping'
    },
  ],
  Manuals: [
    {
      name: 'All Manuals',
      path: '/manuals'
    },
    {
      name: 'Training',
      path: '/manuals/training'
    },
    {
      name: 'Sops',
      path: '/manuals/sops'
    },
    {
      name: 'Rvsm Operations',
      path: '/manuals/rvsm-operations'
    },
    {
      name: 'Hazardous Materials',
      path: '/manuals/hazardous-materials'
    },
    {
      name: 'Minimum Equipment List',
      path: '/manuals/minimum-equipment-list'
    },
    {
      name: 'International Procedures',
      path: '/manuals/international-procedures'
    },
  ],
  Training: [
    {
      name: 'Pilot Training',
      path: '/training'
    },
    {
      name: 'Standardized Training',
      path: '/training/standardized-training'
    },
    {
      name: 'International Training',
      path: '/training/international-training'
    },
    // {
    //   name: 'Compliance Seminar',
    //   path: '/training/understanding-the-why-in-135'
    // },
  ],
  Regulations: [
    {
      name: 'Frequently Asked Regulations (FARs)',
      path: '/regulations'
    },
    {
      name: 'Legal Interpretations',
      path: '/regulations/legal-interpretations'
    },
  ],
  News: '/news',
  'White Papers': '/whitepapers'
}

const NavBar = () => {
  const [isOpen, setOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const location = useLocation()
  const isMobileView = useMediaQuery("(max-width:768px)");

  const toggleNavBar = () => {
    setOpen(!isOpen)
  }

  return <div className='navbar'>
    <FontAwesomeIcon icon={faBars} className='navbar__icon' onClick={toggleNavBar} />
    <div className='navbar__logo' />
    <SlidePanel
      isOpen={isOpen}
      from='left'
      width={isMobileView ? '70%' : '30%'}
      onRequestClose={toggleNavBar}
      hideHeader
      className='navbar__slide-panel'
    >
      <div className='navbar__menu-header'>
        <p>Menu</p>
        <FontAwesomeIcon icon={faClose} onClick={toggleNavBar} />
      </div>
      <div>
        {Object.keys(Menu).map((name, idx) =>
          <Accordion key={idx} transition transitionTimeout={250}>
            {Array.isArray(Menu[name]) ?
              <AccordionItem header={name}>
                {(Menu[name] as any[]).map((item, key) => <div key={key} className={`navbar__menu-item ${location.pathname === item.path ? 'selected' : ''}`} onClick={() => navigate(item.path)}>{item.name}</div>)}
              </AccordionItem> : <div className='item-btn navbar__menu-item--0' onClick={() => navigate(Menu[name] as string)}>{name}</div>
            }
          </Accordion>)}
      </div>
    </SlidePanel>
  </div>
}

export default NavBar;